<template>
  <div v-if="content" v-editable="content" id="seminaires">
    <component :content="blok" :key="blok._uid" v-for="(blok) in content.body" :is="blok.component"></component>
  </div>
</template>

<script>
  import api from "@/api";

  export default {
    data() {
      return {
        content: null
      };
    },
    created() {
      this.fetchData();
    },
    methods: {
      async fetchData() {
        try {
          const res = await api.get(
            `cdn/stories/${this.$i18n.locale}/pages/seminaires-test`
          );
          this.content = res.data.story.content;
        } catch (err) {
            console.log(err);
          //this.$router.push("/404");
        }
      }
    }
  };
</script>

<style lang="scss">

</style>
